import * as React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

import Header from '../header/Header';
import Footer from '../footer/Footer';

import Index from '../index/Index';
import ProductDetails from '../productDetails/ProductDetails';
import ProductList from '../productList/ProductList';
import Search from '../search/Search';
import ComplateOrder from '../payment/ComplateOrder';
import Cart from '../cart/Cart';
import PlaceOrder from '../placeOrder/PlaceOrder';
import OrderResponse from '../orderResponse/OrderResponse';
import PaymentResponse_PayU from '../orderResponse/PaymentResponse_PayU';
import Order from '../order/Order';
import OrderStatus from '../orderStatus/OrderStatus';
import AboutUs from '../aboutus/AboutUs';
import WhyUs from '../whyus/WhyUs';
import ShippingOption from '../shippingOption/ShippingOption';
import ContactUs from '../contactus/ContactUs';
import BulkOrder from '../bulkorder/BulkOrder';
import Feedback from '../feedback/Feedback';
import ReturnPolicy from '../returnpolicy/ReturnPolicy';
import Disclaimer from '../disclaimer/Disclaimer';
import PrivacyPolicies from '../privacyPolicies/PrivacyPolicies';
import Drugpolicy from '../drugpolicy/Drugpolicy';
import FAQ from '../faq/FAQ';
import TermsOfUse from '../termsOfUse/TermsOfUse';
import CounterfeitPolicy from '../counterfeitPolicy/CounterfeitPolicy';
import CustomerSupport from '../customerSupport/CustomerSupport';
import RequestBook from '../requestbook/RequestBook';
import PaymentMethod from '../paymentMethod/PaymentMethod';
import Ecash from '../ecash/Ecash';
import CancelRequest from '../cancelRequest/CancelRequest';
import HomeStore from '../homeStore/HomeStore';


const Master = (props : any) =>{


return(<>

   
 {/* Body Start */}


<Router>
    <Header></Header> 
    <Routes>
        <Route path='/' element={<Index ></Index>}></Route> 
        <Route path='/:bookNameitemId' element={<ProductDetails></ProductDetails>}></Route>
        <Route path='/:category/:cid' element={<ProductList></ProductList>}></Route>
        <Route path='/Search' element={<Search></Search>}></Route>
        <Route path='/ComplateOrder' element={<ComplateOrder></ComplateOrder>}></Route>
        <Route path='/Cart' element={<Cart></Cart>}></Route>
        <Route path='/PlaceOrder' element={<PlaceOrder></PlaceOrder>}></Route>
        <Route path='/OrderResponse/:OrderId' element={<OrderResponse></OrderResponse>}></Route>
        <Route path='/PaymentResponse_PayU' element={<PaymentResponse_PayU></PaymentResponse_PayU>}></Route>
        <Route path='/Order' element={<Order></Order>}></Route>
        <Route path='/OrderStatus' element={<OrderStatus></OrderStatus>}></Route>

        <Route path='/AboutUs' element={<AboutUs></AboutUs>}></Route>
        <Route path='/Why-Us' element={<WhyUs></WhyUs>}></Route>
        <Route path='/shippingoption' element={<ShippingOption></ShippingOption>}></Route>
        <Route path='/contactus' element={<ContactUs></ContactUs>}></Route>
        <Route path='/bulkorder' element={<BulkOrder></BulkOrder>}></Route>
        <Route path='/feedback' element={<Feedback></Feedback>}></Route>
        <Route path='/returnpolicy' element={<ReturnPolicy></ReturnPolicy>}></Route>
        <Route path='/disclaimer' element={<Disclaimer></Disclaimer>}></Route>
        <Route path='/privacypolicies' element={<PrivacyPolicies></PrivacyPolicies>}></Route>
        <Route path='/drugpolicy' element={<Drugpolicy></Drugpolicy>}></Route>
        <Route path='/faq' element={<FAQ></FAQ>}></Route>
        <Route path='/TermsOfUse' element={<TermsOfUse></TermsOfUse>}></Route>
        <Route path='/CounterfeitPolicy' element={<CounterfeitPolicy></CounterfeitPolicy>}></Route>
        <Route path='/customer-support' element={<CustomerSupport></CustomerSupport>}></Route>
        <Route path='/requestbook' element={<RequestBook></RequestBook>}></Route>
        <Route path='/payment-method' element={<PaymentMethod></PaymentMethod>}></Route>
        <Route path='/Ecash' element={<Ecash></Ecash>}></Route>
        <Route path='/CancelRequest' element={<CancelRequest></CancelRequest>}></Route>
        <Route path='/HomeStore' element={<HomeStore></HomeStore>}></Route>
        
    </Routes>
</Router>

 {/* Body End */}



<Footer></Footer>

</>
);
}

export default Master;



